export default class SVGDrawer {
  constructor(el, htOption) {
    this._el = el;
    this._htOption = htOption;
  }

  draw(oQRCode) {
    const _htOption = this._htOption;
    const _el = this._el;
    const nCount = oQRCode.getModuleCount();
    const nWidth = Math.floor(_htOption.width / nCount);
    const nHeight = Math.floor(_htOption.height / nCount);

    this.clear();

    function makeSVG(tag, attrs) {
      const el = document.createElementNS('http://www.w3.org/2000/svg', tag);
      for (let k in attrs) if (attrs.hasOwnProperty(k)) el.setAttribute(k, attrs[k]);
      return el;
    }

    const svg = makeSVG('svg', {
      viewBox: '0 0 ' + String(nCount) + ' ' + String(nCount),
      width: '100%',
      fill: _htOption.colorLight
    });
    svg.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns', 'http://www.w3.org/2000/svg');
    _el.appendChild(svg);

    svg.appendChild(makeSVG('rect', { fill: _htOption.colorLight, width: '100%', height: '100%' }));
    svg.appendChild(
      makeSVG('rect', { fill: _htOption.colorDark, width: '1', height: '1', id: 'template' })
    );

    const path = [];
    for (let row = 0; row < nCount; row++) {
      for (let col = 0; col < nCount; col++) {
        let width = 0;
        while (col + width < nCount && oQRCode.isDark(row, col + width)) width++;

        if (width > 0) {
          path.push('M' + col + ' ' + row + 'v1h' + width + 'v-1z');
          col += width;
        }
      }
    }

    const child = makeSVG('path', { d: path.join(''), fill: _htOption.colorDark });
    svg.appendChild(child);
  }

  clear() {
    while (this._el.hasChildNodes()) this._el.removeChild(this._el.lastChild);
  }
}
